<template lang="pug">
    div
        h3.sidebar-header.element-normal-bottom.element-medium-top Калькулятор стоимости услуги
        form.contact_form
            div.row
                div.col-md-6
                    div.row
                        div.col-md-6
                            label Кол-во обследуемых:
                            div.form-group
                                input.form-control(
                                    type="text"
                                    v-model="count"
                                    v-mask="'##'"
                                )
                        div.col-md-6
                            label Срок готовности:
                            div.form-group
                                select.form-control(
                                    v-model="analizeType"
                                )
                                    option(
                                        value="express"
                                    ) 4 дня
                    div.row
                        div.col-md-12
                            label Ваше местонахождение:
                            div.form-group
                                select.form-control(
                                    v-model="position"
                                )
                                    option(
                                        value="0"
                                    ) - выберите местоположение -
                                    option(
                                        v-for="(position, positionId) in positions"
                                        v-bind:value="positionId"
                                    ) {{ position['name'] }}
                div.col-md-6
                    div.pricing-col
                        div.pricing-body
                            div.pricing-price
                                h4(
                                    v-if="cost"
                                ) {{ cost }}
                                    small(
                                        style="color: #ffffff;"
                                    ) &nbsp;руб.
                                h4(
                                    v-else
                                ) &mdash;
                                p В итоговую сумму включены выезд мобильной бригады, взятие мазков и выполнение анализа на {{count}} {{ declOfNum(count, ['человека', 'человек', 'человек']) }}.
        hr
</template>

<script>

    import _ from 'lodash';

    export default {
        props: [

        ],
        data() {
            return {
                count: 1,
                position: 0,
                analizeType: 'express',
                base_price: 1900,
                express_base_price: 2200,
                positions: {
                    1: {
                        name: 'В пределах МКАД',
                        visit_prices: {
                            1: 3300,
                            //3: 2300,
                            //5: 1800,
                            //10: 300
                        }
                    },
                    2: {
                        name: '20 км от МКАД',
                        visit_prices: {
                            1: 5300,
                            //3: 4300,
                            //5: 3800,
                            //10: 2300
                        }
                    }
                },
                count_sales: {
                    3: 500,
                    5: 1000,
                    10: 2000
                }
            };
        },
        mounted () {

        },
        methods: {
            declOfNum(number, titles) {
                let cases = [2, 0, 1, 1, 1, 2];
                return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
            }
        },
        computed: {
            cost(){
                if(!parseInt(this.count) || !parseInt(this.position)){
                    return false;
                }

                let basePrice = this.base_price;

                if(this.analizeType === 'express'){
                    basePrice = this.express_base_price;
                }

                return basePrice * this.count + this.visitPrice;
                //return this.base_price * this.count + this.visitPrice - this.countSales;
            },
            visitPrice(){
                let price = false;

                for(let i = this.count; i > 0; i--){
                    if(price === false && this.positions[this.position]['visit_prices'][i] !== undefined){
                        price = this.positions[this.position]['visit_prices'][i];
                    }
                }

                return price;
            },
            countSales(){
                let sale = false;

                for(let i = this.count; i > 0; i--){
                    if(!sale && this.count_sales[i]){
                        sale = this.count_sales[i];
                    }
                }

                return sale;
            }
        }
    };
</script>

<style lang="stylus">
    .pricing-col
        margin-bottom: 0;
        padding-bottom: 0;
        margin-top: 30px;

        .pricing-body
            background: #3a4a4c;
            color: #ffffff;
            padding-bottom: 0;
        h4
            background: #86b2b8;
            color: #ffffff !important;
            padding: 15px;
            font-size: 26px;
        p
            text-align: left;
            padding: 5px 10px;
            font-size: 14px;
</style>